import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { GameCard } from "@/components/GameCard";
import { Footer, SectionHeader } from "@/pages/Landing";
import { viewerApi } from "@/lib/api";
import { Library as LibraryIcon } from "lucide-react";

export default function Library() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    viewerApi
      .get("/games", { params: { status: "finished" } })
      .then(({ data }) => setGames(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Header />
      <section className="border-b border-white/10 bg-[#141414]">
        <div className="mx-auto flex max-w-[1400px] items-center gap-4 px-6 py-12">
          <span className="flex h-14 w-14 items-center justify-center bg-[#007AFF]">
            <LibraryIcon className="h-7 w-7 text-white" />
          </span>
          <div>
            <h1 className="font-display text-4xl font-black uppercase tracking-tighter text-white md:text-5xl">
              Replay Library
            </h1>
            <p className="mt-1 text-white/50">Every completed game, ready to watch on demand.</p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 py-14">
        <SectionHeader title="Past Games" />
        {loading ? (
          <p className="font-display uppercase tracking-widest text-white/40">Loading…</p>
        ) : games.length === 0 ? (
          <p className="text-white/40">No completed games in the library yet.</p>
        ) : (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="library-grid">
            {games.map((g) => (
              <GameCard key={g.id} game={g} />
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
